import { assign } from "xstate";
import { TResultContext } from "./types";

export const actions = {
  setParams: assign({
    params: (
      ctx: TResultContext,
      e: {
        type: string;
        order_no: string;
        status: number;
      }
    ) => {
      return {
        order_no: e.order_no,
        status: e.status,
      };
    },
  }),
};
